'use client'
import { ApolloProvider } from '@apollo/client'
import { AuthProvider } from '@core/auth'
import { apolloClient } from '@core/graphql/client'
import { I18NProvider } from '@core/i18n'
import { UIProvider } from '@core/ui-elements'
import { BottomSheetProvider } from '@ui-components/bottom-sheet'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import React, { PropsWithChildren, Suspense } from 'react'

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <Suspense>
      <I18NProvider>
        <UIProvider>
          <ApolloProvider client={apolloClient}>
            <NuqsAdapter>
              <AuthProvider>
                <BottomSheetProvider>{children}</BottomSheetProvider>
              </AuthProvider>
            </NuqsAdapter>
          </ApolloProvider>
        </UIProvider>
      </I18NProvider>
    </Suspense>
  )
}
